import classNames from 'classnames'
import Link from 'next/link'
import { AnchorHTMLAttributes, DetailedHTMLProps, Ref } from 'react'

/**
 * Link component properties extending HTML anchor attributes
 */
type Props = DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> & {
  href: string
  ref?: Ref<HTMLAnchorElement>
}

/**
 * Styled link component with neon cyan theme
 * @param {Props} props - Link properties including href, className, and other anchor attributes
 * @returns {JSX.Element} Next.js Link component with cyan styling
 */
export const VLink = (props: Props) => {
  return (
    <Link x-component-name="VLink" {...props} className={classNames(`text-cyan-400 hover:text-cyan-300`, props.className)}>
      {props.children}
    </Link>
  )
}
